var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"us-footer-wrap"},[_c('div',{staticClass:"copyright-wrap"},[_c('SysCopyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }